import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/legal/LegalPage";
import { TermsOfUse } from "@/components/legal/LegalModal";

export const Route = createFileRoute("/es/terminos")({
  head: () => ({
    meta: [
      { title: "Términos de uso — Sellavo" },
      { name: "description", content: "Las condiciones para usar Sellavo y publicar anuncios de forma segura." },
      { property: "og:title", content: "Términos de uso — Sellavo" },
      { property: "og:description", content: "Las condiciones para usar Sellavo y publicar anuncios de forma segura." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/es/terminos" }],
  }),
  component: () => <LegalPage title="Términos de uso" intro="Las condiciones para usar Sellavo y publicar anuncios de forma segura."><TermsOfUse /></LegalPage>,
});
